import { useCallback, useRef } from "react"

/** Drops calls while the previous one is still running, so a repeated key can't fire it twice. */
export function useSingleFlight<Args extends unknown[]>(
	run: (...args: Args) => Promise<void>,
) {
	const runRef = useRef(run)
	runRef.current = run
	const inFlightRef = useRef(false)

	return useCallback(async (...args: Args) => {
		if (inFlightRef.current) return
		inFlightRef.current = true
		try {
			await runRef.current(...args)
		} finally {
			inFlightRef.current = false
		}
	}, [])
}
